<template>
  <div>
    <c-eth-gas-option
      type="vaults"
      :gasLimit="gasLimit"
      @update="updateGasPrices"
    >
      <div class="d-flex mt-10">
        <div class="flex-1">
          <div class="text-5 font-weight-medium">Withdrawal Amount</div>
          <div class="d-flex align-center mt-2 text-2">
            <span class="primary--text">{{ txPayload.amount }}</span>
            <span class="gray--text text-uppercase ml-1">{{
              selectedAsset.coin
            }}</span>
          </div>
          <div class="mt-2 gray--text text-5">${{ amountUsd | currency }}</div>
        </div>
        <div class="flex-1">
          <div class="text-5 font-weight-medium">Estimated Transaction Fee</div>
          <div class="d-flex align-center mt-2 text-2">
            <div>
              <span class="primary--text">{{
                txFees.amount | denomFormat
              }}</span>
              <span class="gray--text text-uppercase ml-1">ETH</span>
            </div>
          </div>
          <div class="mt-2 gray--text text-5">
            ${{ txFees.value | currency }}
          </div>
        </div>
      </div>
    </c-eth-gas-option>
    <div>
      <div class="d-flex align-center mt-16">
        <div class="flex-1">
          <c-btn
            @click="approve"
            class="width-100"
            :disabled="Number(rawTx.gas || 0) <= 0"
            >Approve</c-btn
          >
        </div>
        <div class="flex-1 ml-2">
          <c-btn disabled class="width-100">Withdraw</c-btn>
        </div>
      </div>
      <div class="d-flex justify-center mt-4">
        <v-checkbox
          v-model="infiniteCheck"
          label="Approve infinite access"
          class="mr-5 darkgray--text"
          @change="setInfiniteCheck"
        ></v-checkbox>
      </div>
    </div>

    <c-modal
      v-model="shouldShowApproveModal"
      content-class="rounded-10 pa-8 white"
      width="500px"
      persistent
    >
      <approve
        v-if="shouldShowApproveModal"
        v-model="shouldShowApproveModal"
        @close="shouldShowApproveModal = false"
        @onSuccess="onApproveSuccess"
        @onError="onApproveError"
        :txObject="txObject"
        :vault="vaultInfo.type"
        :vaultToken="vaultInfo.token"
        :token="selectedAsset && selectedAsset.coin"
        :zap="selectedAsset && selectedAsset.isZap && 'out'"
      />
    </c-modal>
  </div>
</template>

<script>
import BN from "bignumber.js";
import { mapGetters } from "vuex";
import Approve from "@/components/tx/vaults/Approve";

export default {
  components: {
    Approve,
  },
  props: {
    vaultInfo: Object,
    selectedAsset: Object,
    txPayload: Object,
  },
  data: () => ({
    gasPrices: {},
    gasLimit: 0,
    rawTx: {},
    shouldShowApproveModal: false,
    infiniteCheck: true,
  }),
  computed: {
    ...mapGetters({
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
    }),
    txFees() {
      const amount = new BN(this.gasPrices.gas || 0)
        .multipliedBy(this.gasPrices.maxFeePerGas || 0)
        .dividedBy(1e18)
        .toNumber();
      return {
        amount,
        value: amount * this.getTokenPriceInUsd("eth"),
      };
    },
    txObject() {
      return {
        ...this.rawTx,
        ...this.gasPrices,
      };
    },
    amountUsd() {
      return new BN(this.txPayload.amount)
        .multipliedBy(this.getTokenPriceInUsd(this.selectedAsset.coin))
        .toNumber();
    },
  },
  methods: {
    setInfiniteCheck(value) {
      this.$emit("setInfiniteCheck", value);
    },
    updateGasPrices(prices) {
      this.gasPrices = prices;
    },
    async getRawTx() {
      const rawTx = await this.$store.dispatch("vaults/getApprovalWithdrawalV3RawTx", {
        token: this.vaultInfo.token,
        vault: this.vaultInfo.type,
        amount: this.infiniteCheck ? undefined : this.txPayload.amount
      });
      this.gasLimit = rawTx.gas;
      this.rawTx = rawTx;
    },
    approve() {
      this.shouldShowApproveModal = true;
    },
    onApproveSuccess() {
      this.shouldShowApproveModal = false;
      this.$emit("next");
    },
    onApproveError(error) {
      this.$store.dispatch("addAlert", {
        type: "error",
        title: "Approve access failed",
        message: error.message,
      });
      this.shouldShowApproveModal = false;
    },
  },
  mounted() {
    this.getRawTx();
  },
  watch: {
    infiniteCheck() {
      this.gasLimit = 0;
      this.rawTx = {};
      this.getRawTx();
    },
  },
};
</script>
